export const SESSION_IDLE_TIMEOUT_MS = 12 * 60 * 60 * 1000
export const SESSION_IDLE_ACTIVITY_INTERVAL_MS = 60 * 1000
export const SESSION_IDLE_RETRY_MS = 30 * 1000

const EXEMPT_USER_IDS = new Set([
  "e37374e4-f995-4b7b-b1f3-e22ef2b811c1",
  "7bcdc6fc-5d45-4f12-bbcd-6dce6703cdc0",
])

export const isSessionIdleExempt = (userId: string) => EXEMPT_USER_IDS.has(userId.toLowerCase())

export type SessionIdleStatus = {
  expired: boolean
  exempt: boolean
  expiresAt: string | null
  serverNow: string
}

// The ID remains stable across token refreshes and differs after a new login.
export const getAuthSessionId = (accessToken: string): string | null => {
  try {
    const payload = accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
    const claims = JSON.parse(atob(payload))
    return typeof claims.session_id === "string" ? claims.session_id : null
  } catch {
    return null
  }
}
